module.exports = __webpack_public_path__ + "static/media/partitions_lcs_10y_y.2b09ca2f.csv";